<template>
  <div class="code-select">
    <div v-show="!isSearch" class="value-div">+{{ areaCode }}</div>
    <el-select 
        v-model="areaCode" 
        filterable 
        class="area-list-box" 
        :class="isSearch ? 'show' : false" 
        :placeholder="areaCode" 
        @change="selectChange" 
        @visible-change="onSearch"
        ref="select"
        @hook:mounted="cancalReadOnly"
    >
      <el-option-group class="area-option" v-for="group in areaList" :key="group.group" :label="group.group">
        <el-option v-for="item in group.list" :disabled="item.code === '86'" :key="item.code+item.name" :label="`${item.cnName}/${item.name}`" :value="item.code" />
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'CodeSelect',
  model: {
    prop: 'areaCode',
    event: 'code-change'
  },
  props: {
    areaList: { default() { return [] }, type: Array },
    areaCode: { type: [String, Number], default: '852' }
  },
  data() {
    return {
      isSearch: false
    }
  },
  methods: {
    selectChange() {
      this.$emit('code-change', this.areaCode)
    },
    onSearch(tag) {
        tag ? this.isSearch = true : this.isSearch = false
        this.$nextTick(() => {
            if (!tag) {
                const {select} = this.$refs;
                const input = select.$el.querySelector('.el-input__inner');
                input.removeAttribute('readonly');
            }
        });
    },
    cancalReadOnly(onOff) {
        this.$nextTick(() => {
            if (!onOff) {
                const {select} = this.$refs;
                const input = select.$el.querySelector('.el-input__inner');
                input.removeAttribute('readonly');
            }
        });
    }
  }
}
</script>

<style lang="less">
.code-select {
  position: relative;
  width: 135px;
  height: 100px;
  .value-div {
    position: absolute;
    top: 0;
    left: 5px;
    height: 100px;
    width: 100px;
    line-height: 100px;
    text-align: left;
    text-indent: 10px;
    font-size: 32px;
    color: #33333A;
    // padding-left: 10px;
    // padding-top: 3px;;
  }
  .area-list-box {
    width: 120px;
    // margin: -10px -2px;
  }
  .area-list-box .el-input .el-input__inner {
    opacity: 0;
    padding: 0 10px;
    font-size: 34px;
  }
  .area-list-box.show .el-input .el-input__inner {
    opacity: 1;
    padding: 0 10px;
  }
  .el-input__suffix {
      display: none;
  }
}
.el-select-dropdown.el-popper {
    width: 575px;
    margin: 10px 0;
    font-size: 34px;
    .el-scrollbar {
        height: 575px;
        .el-select-dropdown__wrap {
            height: 575px;
            max-height: 575px;
        }
    }
    .el-select-dropdown__item {
        font-size: 34px;
        height: 50px;
    }
    .popper__arrow {
        top: -40px;
        border-width: 20px;
        border-bottom-color: #ffffff;
        filter: drop-shadow(0 10px 20px rgba(0, 0, 0, .03));
    }
}
.el-select-group__title {
    font-size: 36px;
    line-height: 68px;
}
</style>
